import { DetailInfo, DetailRow } from '../DetailRow/DetailRow'
import { Dimension } from '../../../modules/privateOffer/types'
import { ColumnReadMore, isNonEmptyNumber, numberFormat } from '@labrav/common'
import { get } from 'lodash'
import { useStyles } from './AdditionalUsagePriceView.styles'

type AdditionalUsagePriceViewProps = {
  dimensions?: Dimension[]
  keyName?: string
  priceColumnName?: string
  currencySymbol?: string
}

export const AdditionalUsagePriceView = ({
  dimensions,
  keyName = 'price',
  priceColumnName = 'Customer price',
  currencySymbol,
}: AdditionalUsagePriceViewProps) => {
  const { classes } = useStyles()
  const additionalUsageDimensions = dimensions?.filter(
    dimension =>
      dimension?.isAdditionalUsageAllowed ||
      dimension?.type === 'additional_usage'
  )
  const dimensionsList = (additionalUsageDimensions || []).map(
    (dimension, index) => (
      <DetailRow
        key={`${dimension.label || 'usage'}-${index}`}
        borderBottom={index + 1 !== (additionalUsageDimensions || []).length}
        children={
          <>
            <DetailInfo
              gridSize={4}
              value={
                dimension?.label ? (
                  <ColumnReadMore
                    customCharForRemoveFromMax={15}
                    description={dimension?.label}
                  />
                ) : (
                  '-'
                )
              }
              keyName="dimension-label"
              varient="small"
            />
            <DetailInfo
              gridSize={4}
              varient="small"
              value={
                dimension?.labelDescription ? (
                  <ColumnReadMore
                    customCharForRemoveFromMax={15}
                    description={dimension?.labelDescription}
                  />
                ) : (
                  '-'
                )
              }
              keyName="dimension-label"
            />
            <DetailInfo
              varient="small"
              gridSize={4}
              keyName="dimension-price"
              value={
                isNonEmptyNumber(get(dimension, keyName) as number) ? (
                  <div className={classes.price}>
                    <span className={classes.currency}>{currencySymbol}</span>
                    {numberFormat(get(dimension, keyName) as number, 3)}
                  </div>
                ) : (
                  '-'
                )
              }
            />
          </>
        }
      />
    )
  )
  return (
    <div className={classes.root} data-testid={'additional-usage-dimesnions'}>
      <DetailRow
        borderBottom
        children={
          <>
            <DetailInfo varient="small" gridSize={4} title="Dimension" />
            <DetailInfo varient="small" gridSize={4} title="Description" />
            <DetailInfo
              varient="small"
              gridSize={4}
              title={
                <div className={classes.titleRight}>
                  {priceColumnName} {currencySymbol}
                </div>
              }
            />
          </>
        }
      />
      {dimensionsList}
    </div>
  )
}
